import { render, staticRenderFns } from "./view.html?vue&type=template&id=1512ed37&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=1512ed37&lang=less&scoped=true&"
import style1 from "./mobile.less?vue&type=style&index=1&id=1512ed37&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1512ed37",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1512ed37')) {
      api.createRecord('1512ed37', component.options)
    } else {
      api.reload('1512ed37', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=1512ed37&scoped=true&", function () {
      api.rerender('1512ed37', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/case/index.vue"
export default component.exports